import {RouterModule, Routes} from '@angular/router';

import {BatchstampComponent} from './batchstamp.component';
import {CratingComponent} from './crating/crating.component';
import {CreateComponent} from './create/create.component';
import {ListComponent} from './list/list.component';
import {DetailsComponent} from './details/details.component';

// noinspection TypeScriptValidateTypes
const routes: Routes = [
  {
    path: '',
    component: BatchstampComponent,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'create', component: CreateComponent },
      { path: 'crating', component: CratingComponent },
      { path: 'list', component: ListComponent },
      { path: 'details/:id', component : DetailsComponent},
    ]
  }
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/batchstamp.routing.ts